<script lang="ts" setup>
import { useRuntimeConfig } from 'nuxt/app';
import { computed } from 'vue';
import { AppTypography } from '~/components/base';
import type { Typography } from '~/types/components/base/Typography';

// Figma renders this at footnote size in the app footer; the landing footer
// keeps the larger body size, so the caller decides.
const { type = 'body' } = defineProps<{
  type?: Typography;
}>();

const config = useRuntimeConfig();

// Derived at render time rather than baked in, so the notice never goes stale
// on 1 January without a redeploy.
const currentYear = computed(() => new Date().getFullYear());
</script>

<template>
  <div class="copyright">
    <AppTypography :type="type">
      Copyright {{ currentYear }} {{ config.public.appName }} - &copy; All
      rights reserved
    </AppTypography>
  </div>
</template>

<style lang="scss" scoped>
.copyright {
}
</style>
